module.exports = __webpack_public_path__ + "img/logo-comeup-blanc.1f69174d.webp";